import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  standalone: true
})
export class SearchBarComponent {
  @Input() placeholder: string = 'Search video titles or descriptions...';
  @Input() resetTrigger = false; // 👈 parent will toggle this
  @Output() search = new EventEmitter<string>();

  searchControl = new FormControl('');
  isExpanded = false;

  constructor(private elRef: ElementRef) {}

  ngOnInit() {
    this.searchControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe((value) => this.search.emit(value || ''));
  }

  // 👇 reset search box when tab changes
  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetTrigger'] && this.resetTrigger) {
      this.searchControl.setValue('', { emitEvent: false }); // ✅ clears both form and input
    }
  }

  expandSearch() {
    this.isExpanded = true;
  }

  collapseSearch() {
    // Collapse only if input is empty
    if (!this.searchControl.value?.trim()) {
      this.isExpanded = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInside = this.elRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.collapseSearch();
    }
  }

  clearSearch(event: Event) {
    event.stopPropagation(); // prevent triggering outside click
    this.searchControl.setValue('');
  }

}
